import React from "react";
import { Box, Grid, Typography } from "@mui/material";

function OverView({ storeData }) {
  console.log(storeData, "overview-----------");
  return (
    <Box sx={{ margin: "10px" }}>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <Box>
            <Typography variant="h4">Details</Typography>

            <Box
              sx={{
                border: "2px solid gray",
                borderRadius: "10px",
                width: "60%",
                maxWidth: "600px", // Set max-width for large screens
                margin: "10px 0", // Center the box
                padding: "16px", // Add padding for spacing
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Brand Name
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">
                    {storeData?.storeName}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Currency
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">USD ($)</Typography>
                </Grid>

                {/* <Grid item xs={6}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Category
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">
                    {storeData?.storeCategory}
                  </Typography>
                </Grid> */}

                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Total Product
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">
                    {storeData?.products?.length}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Total Sells
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">-</Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={7}>
          <Box>
            <Typography variant="h4">About</Typography>
            <Box>
              <Typography>{storeData?.storeDescription}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default OverView;
